import React, { ChangeEvent, useState } from 'react';
import {
  Container,
  Card,
  Button,
  CardHeader,
  CardContent,
  CardActions
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddressForm from '../../../Components/AddressForm';
import IAddress from '../../../Model/addressType';
import Company from '../../../Model/company';
import ContactInfoForm from '../../../Components/Contacts/AddContact/ContactInfoForm';
import CompanyForm from '../../../Components/Contacts/AddContact/CompanyForm';
import { addContact } from '../../../api/contacts';
import { IAddContactData } from '../../../Types/Contacts/IAddContactData';
import CustomAlert, { CustomAlertType } from '../../../Components/CustomAlert';

const AddContact = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<IAddContactData>({});
  const [showCompanyForm, setShowCompanyForm] = useState<boolean>(false);
  const [companies, setCompanies] = useState<any[]>([]);
  const [newCompany, setNewCompany] = useState<any>();
  const [company, setCompany] = useState<Company>();
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [errorType, setErrorType] = useState<CustomAlertType>();
  const { t } = useTranslation();
  const saveContact = async () => {
    data?.addresses?.map(
      (address: Partial<IAddress & { postalcode?: string }>) => {
        address.postcode = address.postalcode;
        delete address.postalcode;
      }
    );

    // if (formEvent.checkValidity()) {
    let dataValue = data;
    setLoading(false);
    console.log(company);
    console.log(newCompany);
    if (company?.business_name) {
      dataValue.company = company;
    } else {
      if (newCompany?.business_name) {
        dataValue.company = newCompany;
      }
    }
    console.log(dataValue);

    try {
      const result = await addContact(dataValue);
      if (result) {
        setLoading(false);
        setData({});
        setCompany({
          business_name: '',
          vat: ''
        });
        setNewCompany({
          business_name: '',
          vat: ''
        });
        setShowCompanyForm(false);
        setShowError(true);
        setErrorType(CustomAlertType.INFO);
        setErrorMessage(t('CONTACT_ADDED'));
      }
    } catch (err: any) {
      setShowError(true);
      setErrorType(CustomAlertType.ERROR);
      setErrorMessage(err.response.data.errorMessage);
    }
  };

  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    const field = e.target.id;
    const { value } = e.target;
    const dataValue = Object.assign(data, { [field]: value });
    setData(dataValue);
  };

  const onChangeAddressForm = (e: any, index: number) => {
    const dataAddress = data.addresses || [];
    if (!dataAddress[index]) {
      dataAddress[index] = {};
    }
    Object.assign(dataAddress[index], { [e.target.name]: e.target.value });
    setData({
      ...data,
      addresses: dataAddress
    });
  };

  const createrandomID = () => {
    const id = Date.now();
    return id;
  };

  const removeItem = (
    values: Partial<IAddress>[] | undefined,
    index: number
  ) => {
    (values || []).splice(index, 1);
    return values;
  };

  const addressForm = (address: Partial<IAddress>, index: number) => (
    <>
      <AddressForm
        index={index}
        key={createrandomID()}
        address={address}
        onChangeValue={(e) => onChangeAddressForm(e, index)}
      />
      <div className="text-right mb-5">
        <Button
        size='small'
          color='error'
          variant="contained"
          onClick={() => {
            const addresses = data.addresses;

            setData({
              ...data,
              addresses: removeItem(addresses, index)
            });
          }}
        >
          {t('REMOVE_ADDRESS')}
        </Button>
      </div>
    </>
  );

  return (
    <Container style={{ width: 'auto' }}>
      <Card style={{ width: '100%', padding: 0 }}>
        <CardHeader title={t('ADD_CONTACT')} className='dialogTitle'/>
        <CardContent style={{ width: '100%' }}>
          <ContactInfoForm onChangeValue={(e: any) => onChangeValue(e)} />
          <div className="text-right">
              <Button  color='success' variant='contained' onClick={() => setShowCompanyForm(!showCompanyForm)}>
                {t('ADD_COMPANY')}
              </Button>
          </div>
          {showCompanyForm && (
            <CompanyForm
              loading={loading}
              setNewCompany={(value: string) =>
                setNewCompany({ ...newCompany, business_name: value })
              }
              setBusinessName={(value: any) =>
                setNewCompany({ ...newCompany, business_name: value })
              }
              setVat={(value: any) =>
                setNewCompany({ ...newCompany, vat: value })
              }
              setCompany={(value: any) => setCompany(value)}
              setLoading={(value: boolean) => setLoading(value)}
              companies={companies}
              setCompanies={(value: any) => setCompanies(value)}
              company={company}
              newCompany={newCompany}
            />
          )}
          <h3>
            {t('CONTACT_ADDRESSES')}
            <div className="float-right">
              <Button
              size='small'
              color='info'
              variant="contained"
                onClick={() => {
                  const newAddressesData = data.addresses || [];
                  setData({
                    ...data,
                    addresses: [...newAddressesData, {}]
                  });
                }}
              >
                {t('+')}
              </Button>
            </div>
          </h3>
          {data.addresses?.map((address: Partial<IAddress>, index: number) =>
            addressForm(address, index)
          )}
        

        <CardActions>
          <Button variant='contained' onClick={() => saveContact()}>{t('SAVE')}</Button>
        </CardActions>
        </CardContent>
      </Card>
      <CustomAlert
          type={errorType}
          show={showError}
          message={errorMessage}
          onClose={() => { setShowError(false); setErrorMessage('');}} />
    </Container>
  );
};

export default AddContact;
